import { BaseService, } from '../types/index.js';
export class Receive extends BaseService {
    getReceiveNetworkList(params) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/transfer/getReceiveNetworkList',
            params,
        });
    }
    fetchTransferToken(params) {
        const serializedParams = new URLSearchParams();
        for (const [key, value] of Object.entries(params)) {
            serializedParams.append(key, value);
        }
        return this._request.send({
            method: 'POST',
            url: '/api/app/transfer/connect/token',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: serializedParams.toString(),
        });
    }
    getDepositInfo(params, headers) {
        return this._request.send({
            method: 'GET',
            url: '/api/app/transfer/deposit/info',
            params,
            headers,
        });
    }
}
